import { AxiosResponse } from "axios";
import $api from "..";
import { ISendMessageResult } from "../common/api_interfaces/chat/ISendMessageResult";
import { IMessageGroup } from "../common/api_interfaces/chat/IMessageGroup";
import { IEditMessage } from "../common/api_interfaces/chat/IEditMessage";
import { ISendMessage } from "../common/api_interfaces/chat/ISendMessage";

export default class ChatService {
    async deleteMessage(idMessage: number): Promise<AxiosResponse<void>> {
        return $api.get<void>(`message/delete?idMessage=${idMessage}`);
    }

    async sendMessage(body: ISendMessage): Promise<AxiosResponse<ISendMessageResult>> {
        return $api.post<ISendMessageResult>(`message/send`, body);
    }

    async saveEditMessage(body: IEditMessage): Promise<AxiosResponse<boolean>> {
        return $api.post<boolean>(`message/edit`, body);
    }

    async getChatMessages(chatId: number): Promise<AxiosResponse<IMessageGroup[]>> {
        return $api.get<IMessageGroup[]>(`message/list?chatId=${chatId}`);
    }
}
